export class ResourceExperienceManagersDto {
    ExperienceManagers: ExperienceManagers[];
    IsEnabledExperienceManager: boolean;
}

export class ExperienceManagers {
    REM_ResourceID: number;
    ExperienceManagerName: string;
    ResourceId: number;
    InstanceId: number
}